import React from 'react';

const NavDivider: React.FC = () => {
  return <li className="navbar-item divider flex-shrink-0" ><div className="divider" /></li>;
};

export default NavDivider;
